import ApiService from '@/helpers/api.service';
const API = new ApiService();

import ApiService2 from '@/helpers/api.service.ext';
const API2 = new ApiService2();

import ApiServiceV6 from '@/helpers/api.service.v6lite';
const APIV6 = new ApiServiceV6();

import moment from "moment";
import { Storage } from "aws-amplify";
const S3_FOLDER = "eload-special-category";

// Endpoints

export const state = {
  loadPromoList: [],
  loadPromoPageInfo: {
    total: 0
  },
  loadCategoryList: [],
  loadCategoryPageInfo: {
    total: 0
  },
  loadSpecialCategoryList: [],
  loadAllSpecialCategoryList: [],
  loadSpecialCategoryPageInfo: {
    total: 0
  },
  loadSpecialCategoryDetails: {},
  loadTopupsList: [],
  loadTopupsPageInfo: {
    total: 0
  },
  loadNetworkList: [],
  loadNetworkPageInfo: {
    total: 0
  },
  loadNetworkListAll: [],
  loadNetworkAllPageInfo: {
    total: 0
  },
  loadNetworkGroupListAll: [],
  loadNetworkGroupAllPageInfo: {
    total: 0
  },
  loadBannerList: [],
  loadBannerPageInfo: {
    total: 0
  },
  loadCampaignList: [],
  loadCampaignPageInfo: {
    total: 0
  },
  loadProvidersList: [],
  loadProvidersPageInfo: {
    total: 0
  },
  loadNetworkGroupList: [],
  loadNetworkGroupPageInfo: {
    total: 0
  },
  requirementPresets: [],
  errors: null,
  campaignManagerList: [],
  rebateLogsList: [],
  rebateLogsPageInfo: {
    total: 0
  },
  scheduleRebateLogsList: [],
  scheduleRebateLogsPageInfo: {
    total: 0
  },

  // Scheduler Eload Promo
  
  schedulePromoLogsList: [],
  schedulePromoLogsPageInfo: {
    total: 0
  },

  // SKU Field Logs
  skuFieldLogsList: [],
  skuFieldLogsPageInfo: {
    total: 0
  },
}

export const mutations = {
  UPDATE_LOADPROMO_LIST(state, list) {
    state.loadPromoList = list;
  },
  UPDATE_LOADPROMO_PAGE_INFO(state, total) {
    state.loadPromoPageInfo.total = total;
  },
  UPDATE_LOADCATEGORY_LIST(state, list) {
    state.loadCategoryList = list;
  },
  UPDATE_LOADCATEGORY_PAGE_INFO(state, total) {
    state.loadCategoryPageInfo.total = total;
  },
  UPDATE_LOADSPECIALCATEGORY_LIST(state, list) {
    state.loadSpecialCategoryList = list;
  },
  UPDATE_LOADSPECIALCATEGORY_PAGE_INFO(state, total) {
    state.loadSpecialCategoryPageInfo.total = total;
  },
  UPDATE_LOADSPECIALCATEGORY_DETAILS(state, value) {
    state.loadSpecialCategoryDetails = value;
  },
  UPDATE_LOADALLSPECIALCATEGORY_LIST(state, list) {
    state.loadAllSpecialCategoryList = list;
  },
  UPDATE_LOADTOPUPS_LIST(state, list) {
    state.loadTopupsList = list;
  },
  UPDATE_LOADTOPUPS_PAGE_INFO(state, total) {
    state.loadTopupsPageInfo.total = total;
  },
  UPDATE_NETWORK_LIST(state, list) {
    state.loadNetworkList = list;
  },
  UPDATE_NETWORK_LIST_ALL(state, list) {
    state.loadNetworkListAll = list;
  },
  UPDATE_NETWORK_PAGE_INFO(state, total) {
    state.loadNetworkPageInfo.total = total;
  },
  UPDATE_NETWORK_GROUP_LIST_ALL(state, list) {
    state.loadNetworkGroupListAll = list;
  },
  UPDATE_NETWORK_ALL_PAGE_INFO(state, total) {
    state.loadNetworkAllPageInfo.total = total;
  },
  UPDATE_NETWORK_GROUP_ALL_PAGE_INFO(state, total) {
    state.loadNetworkGroupAllPageInfo.total = total;
  },
  UPDATE_BANNER_LIST(state, list) {
    state.loadBannerList = list;
  },
  UPDATE_BANNER_PAGE_INFO(state, total) {
    state.loadBannerPageInfo.total = total;
  },
  UPDATE_CAMPAIGN_LIST(state, list) {
    state.loadCampaignList = list;
  },
  UPDATE_CAMPAIGN_PAGE_INFO(state, total) {
    state.loadCampaignPageInfo.total = total;
  },
  UPDATE_PROVIDERS_LIST(state, list) {
    state.loadProvidersList = list;
  },
  UPDATE_PROVIDERS_PAGE_INFO(state, total) {
    state.loadProvidersPageInfo.total = total;
  },
  UPDATE_NETWORK_GROUP_LIST(state, list) {
    state.loadNetworkGroupList = list;
  },
  UPDATE_NETWORK_GROUP_PAGE_INFO(state, total) {
    state.loadNetworkGroupPageInfo.total = total;
  },
  SET_PROD_ERRORS(state, errors) {
    state.errors = errors;
  },
  UPDATE_PRESETS(state, presets){
    state.requirementPresets = presets;
  },
  UPDATE_CAMPAIGN_MANAGER_LIST(state, campaignManagerList){
    state.campaignManagerList = campaignManagerList;
  },
  UPDATE_REBATE_LOGS(state, logs){
    state.rebateLogsList = logs;
  },
  UPDATE_REBATE_LOGS_PAGE_INFO(state, total){
      state.rebateLogsPageInfo.total = total;
  },
  UPDATE_SCHEDULE_REBATE_LOGS(state, logs){
    state.scheduleRebateLogsList = logs;
  },
  UPDATE_SCHEDULE_REBATE_LOGS_PAGE_INFO(state, total){
      state.scheduleRebateLogsPageInfo.total = total;
  },
  UPDATE_SCHEDULE_PROMO_LOGS(state, params) {
    const {rows, total} = params;
    state.schedulePromoLogsList = rows;
    state.schedulePromoLogsPageInfo.total = total;
  },
  UPDATE_SKU_FIELD_LOGS(state, logs) {
    state.skuFieldLogsList = logs;
  },
  UPDATE_SKU_FIELD_LOGS_PAGE_INFO(state, total) {
    if (!state.skuFieldLogsPageInfo) {
      state.skuFieldLogsPageInfo = {};
    }
    state.skuFieldLogsPageInfo.total = total;
  },
}

export const actions = {
  getLoadPromoList(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/sku/list`, params.body)
        .then(({ data }) => {
          context.commit('UPDATE_LOADPROMO_LIST', data.message.rows);
          context.commit('UPDATE_LOADPROMO_PAGE_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  actionLoadPromo(context, params) {
    console.log(params);
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/sku/${params.action}`, params.body)
        .then(({ data }) => {
          console.log(data);
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject(response);
        });
    });
  },
  // End eload actions

  getLoadCategoryList(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/category/list`, params)
        .then(({ data }) => {
          context.commit('UPDATE_LOADCATEGORY_LIST', data.message.rows);
          context.commit('UPDATE_LOADCATEGORY_PAGE_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  actionCategory(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/category/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve()
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  // End category actions

  getLoadTopupsList(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/topups/list`, params)
        .then(({ data }) => {
          context.commit('UPDATE_LOADTOPUPS_LIST', data.message.rows);
          context.commit('UPDATE_LOADTOPUPS_PAGE_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  actionTopups(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/topups/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getEloadPromoDetails(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/sku/eload-promo-details`, params.body)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  getEloadCategoryDetails(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/category/category-details`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  getEloadNetworkList(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/network/list`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_NETWORK_LIST', data.message.rows);
            context.commit('UPDATE_NETWORK_PAGE_INFO', data.message.pageInfo.total);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  getEloadNetworkListAll(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/network/listAll`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_NETWORK_LIST_ALL', data.message.rows);
            context.commit('UPDATE_NETWORK_ALL_PAGE_INFO', data.message.pageInfo.total);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  getEloadNetworkGroupListAll(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/network-group/listAll`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_NETWORK_GROUP_LIST_ALL', data.message.rows);
            context.commit('UPDATE_NETWORK_GROUP_ALL_PAGE_INFO', data.message.pageInfo.total);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  actionNetwork(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/network/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data.message)
          } else {
            reject(data)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  actionNetworkGroup(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/network-group/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data.message)
          } else {
            reject(data)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },

  getNetworkInfo(context, id) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/network/info`, { id: id })
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
        })
    });
  },

  getNetworkGroupInfo(context, id) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/network-group/info`, { id: id })
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
        })
    });
  },

  getEloadBannerList(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/banner/list`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_BANNER_LIST', data.message.rows);
            context.commit('UPDATE_BANNER_PAGE_INFO', data.message.pageInfo.total);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });

  },
  createEloadBanner(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/banner/create`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data);
            console.log("create brand err");
          } else {
            resolve();
            console.log("create brand resolve");
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
        })
    });
  },
  deleteEloadBanner(context, id) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/banner/delete`, { bannerId: id })
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
        })
    });
  },
  getEloadBannerInfo(context, id) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/banner/info`, { id: id })
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
        })
    });
  },
  updateEloadBanner(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/banner/update`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
        })
    });
  },
  getEloadBannerSequenceList(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/banner/sequence-item`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
        })
    });
  },
  getEloadCampaignList(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/list`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_CAMPAIGN_LIST', data.message.rows);
            context.commit('UPDATE_CAMPAIGN_PAGE_INFO', data.message.pageInfo.total);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  getEloadCampaignPresets(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/presets`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_PRESETS', data.message);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  createEloadCampaign(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/create`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  getEloadCampaignDetails(context, campaignId) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/detail`, { campaignId: campaignId })
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data.message);
          } else {
            resolve(data.message);
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  updateEloadCampaign(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/update`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  deleteEloadCampaign(context, campaignId) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/delete`, { campaignId: campaignId })
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  performCampaignAction(context, params){
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/action`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  updateEloadCampaignStatus(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/update-status`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  endEloadCampaign(context, params){
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/end-campaign`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  voidEloadCampaign(context, params){
    return new Promise((resolve, reject) => {
      API.post(`/eload/campaign/void-campaign`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  getEloadProviders(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/sku/list-providers`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_PROVIDERS_LIST', data.message.rows);
            context.commit('UPDATE_PROVIDERS_PAGE_INFO', data.message.rows.length);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  getEloadNetworkGroups(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/sku/list-network-groups`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_NETWORK_GROUP_LIST', data.message.rows);
            context.commit('UPDATE_NETWORK_GROUP_PAGE_INFO', data.message.rows.length);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },
  actionProvider(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/provider/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject(response.data);
        });
    });
  },
  updatePromoStatus(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/eload/sku/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject(response.data);
        });
    });
  },
  fetchCampaignLineManagers(context, campaignId){
    return new Promise((resolve, reject) => {
        API.post(`/eload/campaign/line-managers`, { campaignId: campaignId })
        .then(({ data }) => {
            if(data.status === "ok") {
                context.commit('UPDATE_CAMPAIGN_MANAGER_LIST', data.message.rows);
                resolve()
            } else {
                reject(data.message)
            }
        })
        .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
        });
    });
  },
  getRebateLogsList(context, params) {
    return new Promise((resolve, reject) => {
        API.post(`/eload/sku/list-rebate-logs`, params.body)
        .then(({ data }) => {
            context.commit('UPDATE_REBATE_LOGS', data.message.rows);
            context.commit('UPDATE_REBATE_LOGS_PAGE_INFO', data.message.pageInfo.total);
            resolve();
        })
        .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
        });
    });        
  },
  getScheduleRebateLogsList(context, params) {
    return new Promise((resolve, reject) => {
      console.log(params);
      API.post(`/eload/topups/list-schedule-rebate-logs`, params.body)
        .then(({ data }) => {
            context.commit('UPDATE_SCHEDULE_REBATE_LOGS', data.message.rows);
            context.commit('UPDATE_SCHEDULE_REBATE_LOGS_PAGE_INFO', data.message.pageInfo.total);
            resolve();
        })
        .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
        });
    });        
  },

// Scheduler Eload Promo
  actionEloadPromoSchedule(context, params){
    return new Promise((resolve, reject) => {
      const {action, body} = params;
      API2.post(`/eload/promo/scheduler/${action}`, body)
        .then(({ data }) => {
          console.log("actionEloadPromoSchedule data: ", data);
          
          if(action == 'logs') context.commit('UPDATE_SCHEDULE_PROMO_LOGS', {rows: data.message.rows, total: data.message.pageInfo.total});
          else if(action == 'promos') 
          {
            context.commit('UPDATE_LOADPROMO_LIST', data.message.rows);
            context.commit('UPDATE_LOADPROMO_PAGE_INFO', data.message.pageInfo.total);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit('SET_PROD_ERRORS', response.message);
          console.log("ERROR:", response);
          reject(response);
        });
    });
  },
  actionMassEloadPromoUpdate(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`/eload/promo/scheduler/mass-update`, params)
        .then(({ data }) => {
          resolve(data.message);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  getLoadSpecialCategoryList(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/category/list-special-category`, params)
        .then(({ data }) => {
          context.commit('UPDATE_LOADSPECIALCATEGORY_LIST', data.message.rows);
          context.commit('UPDATE_LOADSPECIALCATEGORY_PAGE_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getAllLoadSpecialCategoryList(context) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/category/all-special-category`)
        .then(({ data }) => {
          context.commit('UPDATE_LOADALLSPECIALCATEGORY_LIST', data.message.rows);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getLoadSpecialCategoryDetails(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/category/special-category-details`, params)
        .then(({ data }) => {
          context.commit('UPDATE_LOADSPECIALCATEGORY_DETAILS', data.message.category);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  actionSpecialCategory(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/eload/category/${params.action}-special-category`, params)
        .then(({ status, data }) => {
          if (data.status === "ok") {
            resolve({ status })
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject(response);
        });
    });
  },
  // End special category actions

  async uploadSpecialCategoryIcon2(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["svg+xml"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(365, 'days').toDate(),
      }

      if(params.type == 'svg+xml'){
        metadata['contentType'] = 'image/svg+xml';
      }

      let s3_loc = `${S3_FOLDER}/icons/${params.filename}`;

      // console.log(">>>>>>>",metadata['contentType']);
      Storage.put(s3_loc, params.base64, metadata)
        .then(stored => {
            // console.log(stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  },

  // SKU Field Logs
  getSkuFieldLogs(context, params) {
    return new Promise((resolve, reject) => {
      console.log('getSkuFieldLogs action called with params:', params);
      APIV6.post('/eload/sku/list-sku-logs', params)
        .then(({ data }) => {
          console.log('API response received:', data);
          if (data.status === 'ok') {
            const rows = data.message.rows || [];
            const total = data.message.pageInfo?.total || 0;
            console.log('Committing to store - rows:', rows.length, 'total:', total);
            context.commit('UPDATE_SKU_FIELD_LOGS', rows);
            context.commit('UPDATE_SKU_FIELD_LOGS_PAGE_INFO', total);
            resolve(data);
          } else {
            console.error('API returned non-ok status:', data);
            reject(data);
          }
        })
        .catch((error) => {
          console.error('API call failed:', error);
          const response = error?.response;
          context.commit('SET_PROD_ERRORS', response?.data?.errors || 'Error fetching logs');
          reject(error);
        });
    });
  },
}

export const getters = {

}